"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepEmbeddingComponent = exports.PrepEmbedding = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../gen-src/Localize");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var SubspaceSlice_1 = require("../store/slice/SubspaceSlice");
var PredictiveModelThunk_1 = require("../store/thunk/PredictiveModelThunk");
var TestIds_1 = require("../util/TestIds");
var Utils_1 = require("../util/Utils");
function PrepEmbedding(props) {
    var flowEditorProps = { draftLuid: props.draftid };
    var prepEmbedContent = props.siteUrls
        ? {
            flowUrl: props.siteUrls.flowEditorDraftPath(flowEditorProps.draftLuid),
            implementationUrl: props.siteUrls.flowEditorEmbeddingPath(),
        }
        : {
            flowUrl: 'https://localhost:8091/flow-editor/flows/new',
            implementationUrl: 'https://floweditor-fast.tableautest.com/flow-editor/embedding/tableau.prep.embedding.1.latest.js',
        };
    React.useEffect(function () {
        if (customElements.get('tableau-flow') === undefined) {
            var tag = document.createElement('script');
            tag.async = false;
            tag.src = prepEmbedContent.implementationUrl;
            var body = document.getElementsByTagName('body')[0];
            body.appendChild(tag);
        }
        return function () {
            //TBC: cleanup
        };
    }, []);
    //We are currently not sure how to invoke a web-component from a
    //Functional Component. Thus we are embedding a class componenet here.
    return React.createElement(PrepEmbeddingComponent, __assign({}, prepEmbedContent));
}
exports.PrepEmbedding = PrepEmbedding;
function PrepEmbeddingComponent(props) {
    var _this = this;
    // eslint-disable-next-line prefer-const
    var prepAttrsRef = React.useRef(null);
    var dispatch = (0, react_redux_1.useDispatch)();
    var flowId = (0, react_redux_1.useSelector)(PredictiveModelSlice_1.selectModel).activeVersion.flowId;
    var versionLuid = (0, react_redux_1.useSelector)(PredictiveModelSlice_1.selectModel).activeVersion.luid;
    var versionLuidRef = React.useRef();
    var getAndDispatchPrepColumns = function () { return __awaiter(_this, void 0, void 0, function () {
        var cleanSteps_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!prepAttrsRef.current) return [3 /*break*/, 2];
                    return [4 /*yield*/, prepAttrsRef.current.getAllStepsOfTypeAsync('clean')];
                case 1:
                    cleanSteps_1 = _a.sent();
                    if (cleanSteps_1 && cleanSteps_1.length > 0) {
                        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var columns, fields, outcomes;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, cleanSteps_1[0].getOutputSchemaAsync()];
                                    case 1:
                                        columns = _a.sent();
                                        if (columns && columns.length > 0) {
                                            fields = getSortedFields(columns);
                                            outcomes = fields.map(function (column) { return ({
                                                name: column.name,
                                                dataType: column.datatype,
                                                cleanStep: cleanSteps_1[0],
                                                type: Utils_1.PredictionType.Undefined,
                                            }); });
                                            dispatch((0, SubspaceSlice_1.setOutcomeList)(outcomes));
                                        }
                                        else {
                                            dispatch((0, SubspaceSlice_1.setOutcomeList)([]));
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 1);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getSortedFields = function (columns) {
        var fields = [];
        columns.forEach(function (column) {
            fields.push(column);
        });
        fields.sort(function (c1, c2) {
            var col1 = c1.name.toUpperCase();
            var col2 = c2.name.toUpperCase();
            if (col1 < col2) {
                return -1;
            }
            if (col1 > col2) {
                return 1;
            }
            return 0;
        });
        return fields;
    };
    var publishAsPrepFlow = function (versionUpdate) {
        var _a;
        var flowName = 'TPM flow ' + Date.now().toString();
        (_a = prepAttrsRef.current) === null || _a === void 0 ? void 0 : _a.publishAsAsync(flowName).then(function (publishAsresults) {
            if (publishAsresults.success) {
                // only update flowId to model version when there is no flowId associated to the version yet
                if (!flowId || versionUpdate) {
                    dispatch((0, PredictiveModelThunk_1.updateModel)({ flowId: publishAsresults.flowId }));
                }
            }
            else {
                var err_response = publishAsresults;
                handlePublishErrors(err_response);
            }
        }).catch(function (publishAsErr) {
            var err_response = JSON.parse(JSON.stringify(publishAsErr));
            handlePublishErrors(err_response);
        });
    };
    var handlePublishErrors = function (props) {
        switch (props.errorType) {
            case Utils_1.PrepPublishErrors.UnpublishedFlow:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepPublishErrorUnpublished());
                break;
            case Utils_1.PrepPublishErrors.PermissionDenied:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepPublishErrorPermissionDenied());
                break;
            case Utils_1.PrepPublishErrors.OverwriteWithoutFlag:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepPublishErrorOverwrite());
                break;
            case Utils_1.PrepPublishErrors.Unknown:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepPublishErrorUnknown());
                break;
            default:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepPublishErrorUnknown());
        }
    };
    var handleCleanStepAddErrors = function (error) {
        switch (error) {
            case Utils_1.AddCleanStepErrors.invalidStepType:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepAddCleanStepErrorInvalidStep());
                break;
            case Utils_1.AddCleanStepErrors.originStepNotFound:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepAddCleanStepErrorOriginStepNotFound());
                break;
            case Utils_1.AddCleanStepErrors.unknown:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepAddCleanStepErrorUnknown());
                break;
            default:
                (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.prepPublishErrorUnknown());
        }
    };
    var publishPrepFlow = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!prepAttrsRef.current) return [3 /*break*/, 2];
                    return [4 /*yield*/, prepAttrsRef.current
                            .publishAsync({ allowOverwrite: true })
                            .then(function (publishresults) {
                            //When called first time since flow has never been published, this will fail with [[PublshErrors | 'UNPUBLISHED_FLOW']]
                            //In case of failure we call publishAs with name.
                            //In the future calls it will publish the changes under the current name and project
                            if (!publishresults.success && publishresults.errorType === 'UNPUBLISHED_FLOW') {
                                publishAsPrepFlow(false);
                            }
                            else if (!publishresults.success) {
                                var err_response = publishresults;
                                handlePublishErrors(err_response);
                            }
                        })
                            .catch(function (publishAsErr) {
                            var err_response = JSON.parse(JSON.stringify(publishAsErr));
                            handlePublishErrors(err_response);
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleInputStepAddedEvent = function (inputStep) { return __awaiter(_this, void 0, void 0, function () {
        var cleanStepResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!inputStep) return [3 /*break*/, 2];
                    console.log("recieved inputstepadded event with detail: ".concat(JSON.stringify({
                        connectionName: inputStep.connectionName,
                        id: inputStep.id,
                        type: inputStep.type,
                    })));
                    return [4 /*yield*/, inputStep.addStepAfterAsync('clean')];
                case 1:
                    cleanStepResponse = _a.sent();
                    if (!cleanStepResponse.success) {
                        handleCleanStepAddErrors(cleanStepResponse.errorType);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (prepAttrsRef.current) {
            prepAttrsRef.current.src = props.flowUrl;
            prepAttrsRef.current.displayMode = 'singleStep';
            prepAttrsRef.current.hideAppToolbar = true;
            prepAttrsRef.current.hideMenuBar = true;
            prepAttrsRef.current.connectionBehavior = 'singleInputWithReplace';
            prepAttrsRef.current.addEventListener('documentstatechanged', function (evt) { return __awaiter(_this, void 0, void 0, function () {
                var cleanSteps;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(evt.detail.draftState === 'unpublished-changes')) return [3 /*break*/, 2];
                            dispatch((0, SubspaceSlice_1.updateIsFlowpublished)(false));
                            return [4 /*yield*/, publishPrepFlow()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!(evt.detail.draftState === 'all-changes-published')) return [3 /*break*/, 6];
                            dispatch((0, SubspaceSlice_1.updateIsFlowpublished)(true));
                            cleanSteps = [];
                            if (!prepAttrsRef.current) return [3 /*break*/, 6];
                            return [4 /*yield*/, prepAttrsRef.current.getAllStepsOfTypeAsync('clean')];
                        case 3:
                            cleanSteps = _a.sent();
                            if (!(cleanSteps && cleanSteps.length > 0 && cleanSteps[0] !== undefined)) return [3 /*break*/, 6];
                            return [4 /*yield*/, cleanSteps[0].getOutputSchemaAsync()];
                        case 4:
                            _a.sent();
                            return [4 /*yield*/, cleanSteps[0].selectAsync()];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6: return [4 /*yield*/, getAndDispatchPrepColumns()];
                        case 7:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
            prepAttrsRef.current.addEventListener('inputstepadded', function (evt) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, handleInputStepAddedEvent(evt.detail.stepAdded)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        return function () {
            //TBC: cleanup
        };
    }, []);
    React.useEffect(function () {
        if (prepAttrsRef.current) {
            if (!versionLuidRef.current) {
                versionLuidRef.current = versionLuid;
            }
            else if (versionLuidRef.current !== versionLuid) {
                publishAsPrepFlow(true);
            }
        }
    }, [versionLuid]);
    return React.createElement("tableau-flow", { ref: prepAttrsRef, testId: TestIds_1.CONNECT_BUTTON_PREP_EMBEDDING_TEST_ID });
}
exports.PrepEmbeddingComponent = PrepEmbeddingComponent;
//# sourceMappingURL=PrepEmbedding.js.map